export default __webpack_public_path__ + "static/media/otherDog.59688e54.gif";